import React from 'react'
import Retry from './Retry'
import jigglypuff from './madjigglypuff.png'
import fatpikachu from './425-4256407_anime-pokemon-png-transparent-image-fat-pikachu-png.png'
import './Result.css'

const Result = (props) => {
    return (
        <div id="results">
   <div>
    <h1>Your final score was {props.score}!</h1>
    {props.score > 3 ? <img src={fatpikachu} alt='Fat Pikachu' className="resultmon"></img> : <img src={jigglypuff} alt='Mad Jigglypuff' className="resultmon"></img>}
    </div>

    <div>
        <Retry reset={props.reset} />
        </div>
        </div>
    )
}

export default Result
